import { render, staticRenderFns } from "./lp-christmas-gifts.vue?vue&type=template&id=7a70aaf8&scoped=true"
import script from "./lp-christmas-gifts.vue?vue&type=script&lang=js"
export * from "./lp-christmas-gifts.vue?vue&type=script&lang=js"
import style0 from "./lp-christmas-gifts.vue?vue&type=style&index=0&id=7a70aaf8&prod&scoped=true&lang=css"
import style1 from "./lp-christmas-gifts.vue?vue&type=style&index=1&id=7a70aaf8&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70aaf8",
  null
  
)

export default component.exports